import { AlertCircle, Loader2 } from "lucide-react";
import { clp, fmtDate, OVERNIGHT } from "@/lib/format";

const Row = ({ k, v, testid, strong }) => (
  <div className={`flex justify-between gap-4 py-1.5 ${strong ? "font-semibold text-base" : "text-sm"}`}>
    <span className={strong ? "" : "text-muted-foreground"}>{k}</span>
    <span className="text-right tabular-nums" data-testid={testid}>{v}</span>
  </div>
);

export function SummaryCard({ quote, loading, compact }) {
  if (!quote) return (
    <div className="rounded-3xl bg-white border border-border p-6 text-sm text-muted-foreground" data-testid="summary-empty">
      Selecciona fecha y experiencia para ver el precio.
    </div>
  );
  const on = OVERNIGHT.includes(quote.experience);
  return (
    <div className="rounded-3xl bg-white border border-border p-6" data-testid="booking-summary">
      <div className="flex items-center justify-between">
        <p className="eyebrow">Resumen</p>
        {loading && <Loader2 className="h-4 w-4 animate-spin text-muted-foreground" />}
      </div>
      {quote.experience_name && <h4 className="mt-2 font-serif text-2xl" data-testid="summary-experience">{quote.experience_name}</h4>}
      {quote.check_in && (
        <div className="mt-3 border-b border-border pb-3">
          <Row k={on ? "Entrada" : "Fecha"} v={`${fmtDate(quote.check_in)}${on ? ` · ${quote.hora_inicio}` : ""}`} testid="summary-checkin" />
          {on && <Row k="Salida" v={`${fmtDate(quote.check_out)} · ${quote.hora_fin}`} testid="summary-checkout" />}
          {on ? <Row k="Noches" v={quote.nights} testid="summary-nights" /> : <Row k="Horario" v={`${quote.hora_inicio} a ${quote.hora_fin}`} />}
          <Row k="Personas" v={quote.billed_guests !== quote.guests ? `${quote.guests} (se cobran ${quote.billed_guests})` : quote.guests} testid="summary-guests" />
          {quote.units > 0 && <Row k={quote.experience === "carpas" ? "Carpas" : "Casas rodantes"} v={quote.units} />}
        </div>
      )}
      {!compact && quote.base !== undefined && (
        <div className="py-3 border-b border-border">
          <Row k="Experiencia" v={clp(quote.base)} testid="summary-base" />
          {quote.discount > 0 && <Row k={`Promoción: ${quote.promo_title}`} v={`-${clp(quote.discount)}`} testid="summary-discount" />}
          {(quote.extras || []).map((x) => <Row key={x.id} k={`${x.name}${x.qty > 1 ? ` x${x.qty}` : ""}`} v={clp(x.subtotal)} />)}
        </div>
      )}
      {quote.total !== undefined && (
        <div className="pt-3">
          <Row k="Total" v={clp(quote.total)} testid="summary-total" strong />
          <Row k="Abono requerido" v={clp(quote.deposit)} testid="summary-deposit" />
          <Row k="Saldo pendiente" v={clp(quote.balance)} testid="summary-balance" />
        </div>
      )}
      {quote.price_pending && (
        <p className="mt-3 text-xs rounded-xl bg-amber-50 text-amber-800 p-3" data-testid="price-pending-note">
          Algunas tarifas aún no han sido configuradas por administración; el precio final se confirmará contigo.
        </p>
      )}
      {quote.errors?.length > 0 && (
        <div className="mt-3 rounded-xl bg-red-50 text-red-800 p-3 text-sm space-y-1" data-testid="quote-errors">
          {quote.errors.map((e, i) => <p key={i} className="flex gap-2"><AlertCircle className="h-4 w-4 shrink-0 mt-0.5" />{e}</p>)}
        </div>
      )}
    </div>
  );
}
